import { render, staticRenderFns } from "./CounterpartiesUpdateComponent.vue?vue&type=template&id=3d61c171&scoped=true"
import script from "./CounterpartiesUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./CounterpartiesUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61c171",
  null
  
)

export default component.exports